// NFL team metadata: full name + primary color
export const TEAMS = {
  ARI: { name: "Cardinals", city: "Arizona", color: "#97233F" },
  ATL: { name: "Falcons", city: "Atlanta", color: "#A71930" },
  BAL: { name: "Ravens", city: "Baltimore", color: "#241773" },
  BUF: { name: "Bills", city: "Buffalo", color: "#00338D" },
  CAR: { name: "Panthers", city: "Carolina", color: "#0085CA" },
  CHI: { name: "Bears", city: "Chicago", color: "#0B162A" },
  CIN: { name: "Bengals", city: "Cincinnati", color: "#FB4F14" },
  CLE: { name: "Browns", city: "Cleveland", color: "#311D00" },
  DAL: { name: "Cowboys", city: "Dallas", color: "#041E42" },
  DEN: { name: "Broncos", city: "Denver", color: "#FB4F14" },
  DET: { name: "Lions", city: "Detroit", color: "#0076B6" },
  GB: { name: "Packers", city: "Green Bay", color: "#203731" },
  HOU: { name: "Texans", city: "Houston", color: "#03202F" },
  IND: { name: "Colts", city: "Indianapolis", color: "#002C5F" },
  JAX: { name: "Jaguars", city: "Jacksonville", color: "#006778" },
  KC: { name: "Chiefs", city: "Kansas City", color: "#E31837" },
  LAC: { name: "Chargers", city: "L.A.", color: "#0080C6" },
  LAR: { name: "Rams", city: "L.A.", color: "#003594" },
  LV: { name: "Raiders", city: "Las Vegas", color: "#000000" },
  MIA: { name: "Dolphins", city: "Miami", color: "#008E97" },
  MIN: { name: "Vikings", city: "Minnesota", color: "#4F2683" },
  NE: { name: "Patriots", city: "New England", color: "#002244" },
  NO: { name: "Saints", city: "New Orleans", color: "#D3BC8D" },
  NYG: { name: "Giants", city: "N.Y.", color: "#0B2265" },
  NYJ: { name: "Jets", city: "N.Y.", color: "#125740" },
  PHI: { name: "Eagles", city: "Philadelphia", color: "#004C54" },
  PIT: { name: "Steelers", city: "Pittsburgh", color: "#FFB612" },
  SEA: { name: "Seahawks", city: "Seattle", color: "#002244" },
  SF: { name: "49ers", city: "San Francisco", color: "#AA0000" },
  TB: { name: "Buccaneers", city: "Tampa Bay", color: "#D50A0A" },
  TEN: { name: "Titans", city: "Tennessee", color: "#0C2340" },
  WAS: { name: "Commanders", city: "Washington", color: "#5A1414" },
};

export const teamName = (abbr) => (TEAMS[abbr] ? TEAMS[abbr].name : abbr);
export const teamColor = (abbr) => (TEAMS[abbr] ? TEAMS[abbr].color : "#333333");

// ESPN CDN team logos. A few abbreviations differ from our internal codes.
const ESPN_OVERRIDE = { WAS: "wsh" };
export const teamLogo = (abbr) => {
  if (!abbr) return null;
  const code = (ESPN_OVERRIDE[abbr] || abbr).toLowerCase();
  return `https://a.espncdn.com/i/teamlogos/nfl/500/${code}.png`;
};

export const SLOT_LABEL = {
  thu_mon: "THU / MON",
  sun_early: "SUN 1PM / 4PM",
  snf: "SUN NIGHT",
};

// Sportsbook-style spread label showing the favorite and their line (spread = home team's line).
export const formatSpread = (g) => {
  const s = g?.spread;
  if (s === null || s === undefined) return null;
  if (s === 0) return "PK";
  return s < 0 ? `${g.home} ${s}` : `${g.away} -${s}`;
};

// The line for a specific team in a game (home line = spread, away line = -spread).
export const teamSpread = (g, team) => {
  const s = g?.spread;
  if (s === null || s === undefined) return null;
  const v = team === g.home ? s : -s;
  return v === 0 ? "PK" : `${v > 0 ? "+" : ""}${v}`;
};

// The favored team (null on a pick'em or when no line is posted).
export const favoriteTeam = (g) => {
  const s = g?.spread;
  if (s === null || s === undefined || s === 0) return null;
  return s < 0 ? g.home : g.away;
};

// Team that covered: abbr, "PUSH", or null when no line / no scores.
export const coverTeam = (g) => {
  if (g?.spread === null || g?.spread === undefined || g.home_score == null || g.away_score == null) return null;
  const adj = g.home_score + g.spread;
  if (adj > g.away_score) return g.home;
  if (adj < g.away_score) return g.away;
  return "PUSH";
};

export const MODE_LABEL = { straight_up: "Straight Up", ats: "Against the Spread", combo: "Straight Up + Spread" };
